import { getLuminance } from "polished";
import store from "../store";
import ERoute from "../ERoute";
import RouteHelper from "../../helpers/RouteHelper";

export default class WidgetHelper {
  static logoUrl(backgroundColor: string) {
    const widget = store.getState()?.application?.widget

    if (!widget) return null

    const luminance = getLuminance(backgroundColor);
    return luminance < 0.5 ? widget.logo_light_url : widget.logo_dark_url
  }

  static isDeepLink(link: string): boolean {
    const url = new URL(link)
    const pathParts = url.pathname.split('/').filter(part => part !== '')

    // Remove the UUID and locale parts (first two parts)
    // Expected format: /uuid/locale/[collections|articles]/...
    let routeParts = pathParts.slice(2)

    if (pathParts.length > 0 && pathParts[0].includes('-')) {
      // Format with UUID - remove UUID and locale (first two parts)
      routeParts = pathParts.slice(2)
    } else {
      // Format without UUID - remove only locale (first part)
      routeParts = pathParts.slice(1)
    }

    if (
      // Overview
      routeParts.length === 0 ||
      routeParts[0] === 'collections' ||
      routeParts[0] === 'articles'
    ) {
      return true
    }

    return false
  }

  static deepLink(link: string): ERoute {
    const url = new URL(link)
    const pathParts = url.pathname.split('/').filter(part => part !== '')

    // Remove the UUID and locale parts (first two parts)
    // Expected format: /uuid/locale/[collections|articles]/...
    let routeParts = pathParts.slice(2)

    if (pathParts.length > 0 && pathParts[0].includes('-')) {
      // Format with UUID - remove UUID and locale (first two parts)
      routeParts = pathParts.slice(2)
    } else {
      // Format without UUID - remove only locale (first part)
      routeParts = pathParts.slice(1)
    }

    // Overview
    if (routeParts.length === 0) {
      return ERoute.PATH_HELP
    } else if (routeParts[0]) {

      switch (routeParts[0]) {
        case 'collections':
          const collectionId = routeParts[1].split('-')[0]
          return RouteHelper.process(ERoute.PATH_HELP_COLLECTION, { id: collectionId }) as ERoute
        case 'articles':
          const articleId = routeParts[1].split('-')[0]
          return RouteHelper.process(ERoute.PATH_ARTICLE, { id: articleId }) as ERoute
        default:
          console.error(`Unknown deep link format: ${link}`)
      }
    }
  }
}